module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('v-container', {
    staticClass: "pt-0"
  }, [_c('v-card', {
    attrs: {
      "dark": ""
    }
  }, [_c('v-card-title', {
    style: ({
      backgroundColor: _vm.styles.general.theme_color_light
    }),
    attrs: {
      "dark": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "mr-2",
    attrs: {
      "xs1": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": "",
      "dark": ""
    }
  }, [_vm._v("date_range")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "500",
      "font-size": "20px"
    }
  }, [_vm._v("Upcoming Events")])]), _vm._v(" "), (_vm.add) ? _c('v-flex', {
    staticClass: "ml-3",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "xs1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "activator",
      "dark": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openNewModal.apply(null, arguments)
      }
    },
    slot: "activator"
  }, [_vm._v("mdi-plus")]), _vm._v(" "), _c('span', [_vm._v("Add event")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, _vm._l((_vm.events), function(event) {
    return _c('v-list-tile', {
      key: event.eventKey,
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openUpdateModal(event)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      style: ({
        color: _vm.styles.general.theme_color_dark
      }),
      attrs: {
        "x-large": ""
      }
    }, [_vm._v("date_range")])], 1), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "eventitem",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openUpdateModal(event)
        }
      }
    }, [_c('v-list-tile-title', {
      staticStyle: {
        "font-size": "15px",
        "font-weight": "900",
        "text-transform": "capitalize"
      },
      style: ({
        color: _vm.styles.general.theme_color_dark
      })
    }, [_vm._v(_vm._s(event.title.toString()))]), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticStyle: {
        "font-size": "12px",
        "font-weight": "900"
      }
    }, [_vm._v("Event Date: " + _vm._s(event.eventdate))])], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('calendar-modal', {
    attrs: {
      "dialog": _vm.openCalendarModal
    }
  }), _vm._v(" "), _c('new-event-modal', {
    attrs: {
      "groupId": _vm.groupId,
      "trigger": _vm.openEventModal
    },
    on: {
      "closeModal": _vm.closeModal,
      "update:trigger": function($event) {
        _vm.openEventModal = $event
      }
    }
  }), _vm._v(" "), _c('update-event-modal', {
    attrs: {
      "groupId": _vm.groupId,
      "trigger": _vm.openUpdateEventModal,
      "item": _vm.selectedItem
    },
    on: {
      "closeModal": _vm.closeModal,
      "update:trigger": function($event) {
        _vm.openUpdateEventModal = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-edbee86e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/grouppage/events/Top5Events.vue
// module id = 1732
// module chunks = 17